import type { SVGProps } from 'react';

const SvgPlayCircleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.96 35.96" {...props}>
    <path
      fill={props.color}
      d="M17.98 0C8.05 0 0 8.05 0 17.98s8.05 17.98 17.98 17.98 17.98-8.05 17.98-17.98S27.91 0 17.98 0m8.42 19.26-12.5 7.7c-1 .61-2.28-.1-2.28-1.28v-15.4c0-1.17 1.29-1.89 2.28-1.28l12.5 7.7c.95.59.95 1.97 0 2.55z"
    />
  </svg>
);

export default SvgPlayCircleFilled;
